// One set of date words for the staff app. Everything takes an ISO string or a Date and is read in the viewer's time zone.
export type When = string | Date | null | undefined

const asDate = (v: When): Date | null => {
  if (!v) return null
  const d = v instanceof Date ? v : new Date(String(v).length === 10 ? `${v}T12:00:00` : String(v))
  return Number.isNaN(d.getTime()) ? null : d
}

/** "12s", "4 min", "3 h", "2 d": how long ago, in the fewest words. Future times read "in 4 h". */
export function ago(v: When, now = Date.now()): string {
  const d = asDate(v)
  if (!d) return '–'
  const s = Math.round((now - d.getTime()) / 1000)
  const a = Math.abs(s)
  const word = a < 60 ? `${Math.max(a, 1)}s` : a < 3600 ? `${Math.round(a / 60)} min` : a < 172_800 ? `${Math.round(a / 3600)} h` : `${Math.floor(a / 86_400)} d`
  return s < 0 ? `in ${word}` : word
}

/** "4 min ago", or "in 4 h" for a future time. Use this wherever a sentence needs the word "ago". */
export function since(v: When, now = Date.now()): string {
  const a = ago(v, now)
  return a === '–' || a.startsWith('in ') ? a : `${a} ago`
}

/** "Nov 2, 3:14 PM" */
export function when(v: When): string {
  const d = asDate(v)
  return d ? d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '–'
}

/** "Nov 2" */
export function dayOf(v: When): string {
  const d = asDate(v)
  return d ? d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '–'
}

export const ageSeconds = (v: When, now = Date.now()): number | null => {
  const d = asDate(v)
  return d ? (now - d.getTime()) / 1000 : null
}
